import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// BENEFIT_INQUIRY_ATTACHMENT

const mutation = gql`
  mutation benefitInquiryDeleteAttachment($id: ID!) {
    benefitInquiryDeleteAttachment(id: $id) {
      id
      form_attachment {
        id
      }
    }
  }
`
export default function useBenefitInquiryDeleteAttachment() {
  const { onMutate: onBenefitInquiryAttachmentDelete, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'benefitInquiryDeleteAttachment',
      successMessage: 'Attachment deleted'
    })

  return { onBenefitInquiryAttachmentDelete, loading }
}
